/**
 * @generated SignedSource<<4bcf6e10e3f1b405469c69d2a325f755>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutStepLink_buyer$data = {
  readonly hasBankAccounts: boolean | null;
  readonly hasCreditCards: boolean | null;
  readonly hasShippingAddresses: boolean | null;
  readonly " $fragmentType": "CheckoutStepLink_buyer";
};
export type CheckoutStepLink_buyer$key = {
  readonly " $data"?: CheckoutStepLink_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutStepLink_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutStepLink_buyer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasShippingAddresses",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasBankAccounts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCreditCards",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5f492fede9166f135f352ff17cd51e39";

export default node;
